import { render, staticRenderFns } from "./User.vue?vue&type=template&id=8bf77a4a&scoped=true&"
import script from "./User.vue?vue&type=script&lang=ts&"
export * from "./User.vue?vue&type=script&lang=ts&"
import style0 from "./user.scss?vue&type=style&index=0&id=8bf77a4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf77a4a",
  null
  
)

export default component.exports